var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-horizontal paragraph_row paragraph_top_border"},[_c('div',{staticClass:"paragraph_content"},[_vm._v(_vm._s(_vm.item.stdrYear)+". 01")]),_vm._v(" "),_c('div',{staticClass:"paragraph_line"}),_vm._v(" "),_c('div',{staticClass:"paragraph_content"},[_vm._v(_vm._s(_vm.util.formatNumber(_vm.item.pblntfPclnd)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ad74b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/InquiryItem.vue
// module id = null
// module chunks = 